// @flow

import {
  type CheckoutPaymentOptions,
} from './types';
import type { CheckoutPaymentOptionsV2 } from '@tectonics/prs/incoming-payment';

export function getEWalletCheckoutPaymentOptions(checkoutPaymentOptions: CheckoutPaymentOptions | CheckoutPaymentOptionsV2): ImmutableArray<string> {
  return checkoutPaymentOptions.ewallet ?? [];
}
